import classNames from 'classnames';
import CloseButton from '@/shared/components/configurator/CloseButton';
import {
    useActiveBannerStateValue,
    useCurrentBannersStateValue,
    useSetActiveBannersState,
} from '@/shared/components/configurator/atoms/banners-state';
import { useBannerVisibleSetState } from '@/shared/components/configurator/atoms/banners-visible';
import {
    useConfiguratorOpenedCameraPositionValue,
    useSetCameraPosition,
} from '@/shared/components/configurator/atoms/camera-position';
import { useSetConfiguratorStepState } from '@/shared/components/configurator/atoms/configurator-step-state';
import { useConfiguratorZoomedSetState } from '@/shared/components/configurator/atoms/configurator-zoomed';

const ConfiguratorBanners = () => {
    const setStep = useSetConfiguratorStepState();
    const setCameraPosition = useSetCameraPosition();
    const configuratorOpenedCameraPosition = useConfiguratorOpenedCameraPositionValue();
    const setConfiguratorZoomed = useConfiguratorZoomedSetState();
    const banners = useCurrentBannersStateValue();
    const activeBannerSlug = useActiveBannerStateValue();
    const setActiveBannerSlug = useSetActiveBannersState();
    const setBannersVisible = useBannerVisibleSetState();

    return (
        <div className="configurator">
            <div className="configurator-top">
                <div className="configurator-title text-l">Размер баннеров</div>
                <CloseButton
                    onClick={() => {
                        setStep('hero');
                        setCameraPosition(configuratorOpenedCameraPosition);
                        setConfiguratorZoomed(false);
                        setActiveBannerSlug('');
                        setBannersVisible(false);
                    }}
                />
            </div>
            <div className="configurator-body configurator-banners">
                {banners.map((group, i) => {
                    return (
                        <div className="banner-group" key={i}>
                            <div className="banner-group-title text-m">{group.title}</div>
                            <ul className="banners-list list-unstyled">
                                {group.list.map((item, j) => {
                                    return (
                                        <li className="banners-list-item" key={j}>
                                            <button
                                                className={classNames('banners-item', {
                                                    'banner-item--active': activeBannerSlug === item.slug,
                                                })}
                                                onClick={() => {
                                                    setActiveBannerSlug((prev) =>
                                                        prev === item.slug ? '' : item.slug,
                                                    );
                                                }}
                                            >
                                                <div className="banners-item__top">
                                                    <div className="banners-item__slug">{item.slug}</div>
                                                    <div className="banners-item__text text-xxs">{item.text}</div>
                                                </div>
                                                <div className="text-m">
                                                    {item.size ? (
                                                        <>
                                                            {item.size.width}{' '}
                                                            <span className="banners-item-cross">x</span>{' '}
                                                            {item.size.height} мм
                                                        </>
                                                    ) : (
                                                        '—'
                                                    )}
                                                </div>
                                            </button>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ConfiguratorBanners;
